// Firebase Auth restores a persisted session from IndexedDB, which is asynchronous:
// on a cold load `AuthContext.loading` stays true for ~1-2s before we know whether
// anyone is signed in. That is far too late for the public marketing homepage, which
// has to paint immediately.
//
// So we mirror the single bit we need — "is there a session?" — into localStorage,
// which *is* readable synchronously, and consult it during that initial window.

const KEY = 'tep:hasSession';

export const setSessionMarker = (hasSession) => {
  try {
    if (hasSession) localStorage.setItem(KEY, '1');
    else localStorage.removeItem(KEY);
  } catch {
    // Private browsing / storage disabled. Callers degrade to rendering the
    // public page immediately, which is the safe direction to fail.
  }
};

export const hasSessionMarker = () => {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
};
